import { jsx as o, jsxs as w } from "react/jsx-runtime";
import S, { forwardRef as k, useRef as L, useState as l, useMemo as x, Children as a, useCallback as N, useEffect as R } from "react";
import { MoreHoriz as A } from "@mui/icons-material";
import j from "@mui/material/Breadcrumbs";
import p from "styled-components";
import z from "./BreadcrumbsCollapsedMenuDropdown.js";
import O from "./useBreadcrumbsIntersectionObserver.js";
const F = {
  root: "breadcrumbsRoot",
  ol: "breadcrumbsOl",
  li: "breadcrumbsLi",
  separator: "breadcrumbsSeparator"
}, G = p.div.withConfig({
  displayName: "GhostBreadcrumbsContainer"
})([
  "line-height:1.2em;opacity:0 !important;z-index:-1 !important;visibility:hidden !important;pointer-events:none !important;width:85%;display:flex;align-items:center;flex-wrap:nowrap;overflow:hidden;position:absolute;&& > div.ghostBreadcrumb,&& > div.ghostSeparator{font-size:0.875em;line-height:1.2em;white-space:nowrap;}&& > div.ghostSeparator{display:inline-block;margin:0 8px;}"
]), H = p.div.withConfig({
  displayName: "BreadcrumbsContainer"
})([
  "flex-wrap:nowrap;white-space:nowrap;overflow:hidden;width:100%;&& > nav > ol{flex-wrap:nowrap;white-space:nowrap;overflow:hidden;width:100%;}"
]), _ = p(j).withConfig({
  displayName: "StyledBreadcrumbs"
})([
  "&&.breadcrumbsRoot{line-height:1.2em;svg{width:20px;height:20px;}}&& .breadcrumbsLi a{color:",
  ";text-decoration:none;}&& li:not(.breadcrumbsLi) button{height:14px;width:22px;color:",
  ";background-color:",
  ";stroke:",
  ";}&& .breadcrumbsLi:active a{color:",
  ";}&& .breadcrumbsLi:hover a{color:",
  ";text-decoration:underline;}&& .breadcrumbsLi:last-child{color:",
  ";text-decoration:none;cursor:default;}&& .breadcrumbsSeparator{color:",
  ";margin:0px 8px;}"
], ({ theme: e }) => e.primaryFill, ({ theme: e }) => e.text.primary, ({ theme: e }) => e.tertiaryBackground, ({ theme: e }) => e.tertiaryBackground, ({ theme: e }) => e.primarySelected, ({ theme: e }) => e.primaryHover, ({ theme: e }) => e.text.primary, ({ theme: e }) => e.text.primary), E = /* @__PURE__ */ k(({ children: e = void 0, useDynamicCollapse: t = !0, maxItems: v = 3, ...i }, B) => {
  const b = L(null), [g, y] = l(20), [n, C] = l(10), [d, I] = l(10), s = x(() => a.map(e, (r) => ({
    childContent: r,
    // @ts-expect-error - TODO: Fix this typing issue
    breadcrumbId: r == null ? void 0 : r.key
  })), [
    e
  ]), { visibleBreadcrumbs: u } = O(t, b, s), f = x(() => a.toArray(e).slice(n, a.count(e) - d), [
    e,
    d,
    n
  ]), M = N(() => /* @__PURE__ */ o(z, {
    collapsedBreadcrumbs: f
  }), [
    f
  ]);
  return R(() => {
    if (t) {
      const r = Object.values(u).filter((c) => c).length, m = a.count(e);
      r <= m && r !== 0 && (y(Math.max(r, 3)), C(Math.floor(r / 2)), I(Math.ceil(r / 2)));
    }
  }, [
    e,
    t,
    u
  ]), /* @__PURE__ */ w("div", {
    children: [
      t && /* @__PURE__ */ o(G, {
        ref: b,
        children: s == null ? void 0 : s.map((r, m) => {
          const { childContent: c, breadcrumbId: h } = r;
          return /* @__PURE__ */ w(S.Fragment, {
            children: [
              /* @__PURE__ */ o("div", {
                className: "ghostBreadcrumb",
                "data-breadcrumbid": h,
                children: c
              }),
              a.count(e) - 1 > m && /* @__PURE__ */ o("div", {
                className: "ghostSeparator",
                children: /* @__PURE__ */ o("span", {
                  children: i.separator
                })
              })
            ]
          }, h);
        })
      }),
      /* @__PURE__ */ o(H, {
        children: /* @__PURE__ */ o(_, {
          ...i,
          ref: B,
          classes: {
            ...F
          },
          "arial-label": "Breadcrumb",
          maxItems: t ? g : v,
          itemsBeforeCollapse: t ? n : i.itemsBeforeCollapse,
          itemsAfterCollapse: t ? d : i.itemsAfterCollapse,
          slots: {
            CollapsedIcon: t ? M : A
          },
          children: e
        })
      })
    ]
  });
});
E.displayName = "Breadcrumbs";
export {
  E as default
};
